import React from 'react';
// Import individual items rather than "*" to enable tree-shaking
import { Clipboard, Zap } from 'react-feather';

import { Text, TEXT_VARIANTS, TEXT_COLORS } from 'ui/Typography';

/**
 * We support only the explicitly-imported icons.
 * To be expanded in future stories.
 */
const Icon = ({ name }) => {
  switch ((name || '').toLowerCase()) {
    case 'clipboard':
      return <Clipboard width="18" />;
    case 'zap':
      return <Zap width="18" />;
    default:
      return <span>Unsupported iconName: {name}</span>;
  }
};

export default function Notice({ iconName, titleText, bodyText }) {
  return (
    <div className="Notice-Container d-f p-24 mb-16">
      <div className="Notice-Sidebar mr-16">
        <Icon name={iconName} />
      </div>
      <div className="info-well-body">
        <header className="mb-8 us-n">
          <Text
            variant={TEXT_VARIANTS.BODY_BOLD}
            color={TEXT_COLORS.ON_SECONDARY}
          >
            {titleText}
          </Text>
        </header>
        <div className="us-n">
          <Text variant={TEXT_VARIANTS.BODY} color={TEXT_COLORS.ON_SECONDARY}>
            {bodyText}
          </Text>
        </div>
      </div>
    </div>
  );
}
